module.exports = __webpack_public_path__ + "img/bus.36ee803d.svg";